import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { BellRing } from 'lucide-react';
import { Button, Card } from '@tcrd/ui';
import { useToast } from '../../components/toast';
import { api, errorMessage } from '../../lib/api';
import { env } from '../../lib/env';
import { fullScreenAlertAllowed, openFullScreenAlertSettings } from '../../lib/fullscreen-alert';

interface TestResult {
  at: string;
  devices: number;
  results: Array<{ device: string; ok: boolean; error?: string }>;
}

/** Diagnóstico: envía un aviso de "nueva solicitud" en 10 s para probarlo con el teléfono bloqueado. */
export function AlertTestCard() {
  const toast = useToast();
  const [waiting, setWaiting] = useState(false);
  const fullScreen = useQuery({ queryKey: ['fullscreen-alert'], queryFn: fullScreenAlertAllowed, refetchOnWindowFocus: true, staleTime: 0 });
  const last = useQuery({ queryKey: ['test-alert'], queryFn: () => api<TestResult | null>('/notifications/test-alert'), refetchOnWindowFocus: true });

  const run = async () => {
    try {
      await api('/notifications/test-alert', { method: 'POST' });
      setWaiting(true);
      toast('Bloquea el teléfono ahora: el aviso llega en 10 segundos.', 'success');
      setTimeout(() => {
        setWaiting(false);
        void last.refetch();
      }, 15_000);
    } catch (e) {
      toast(errorMessage(e), 'danger');
    }
  };

  const r = last.data;
  return (
    <Card className="p-4 flex flex-col gap-3">
      <div className="flex items-start gap-3">
        <BellRing className="size-5 mt-0.5 text-[var(--text-muted)]" aria-hidden />
        <div className="flex-1">
          <p className="text-sm font-semibold">Avisos de solicitudes nuevas</p>
          <p className="text-xs text-[var(--text-muted)]">Envía un aviso de prueba en 10 segundos. Bloquea el teléfono y comprueba que se enciende la pantalla y suena.</p>
        </div>
      </div>
      {env.isNative && fullScreen.data === false && (
        <button className="tap text-left text-xs font-semibold text-brand-red" onClick={() => void openFullScreenAlertSettings()}>
          Falta activar "Avisos a pantalla completa" → tocar aquí
        </button>
      )}
      <Button variant="secondary" loading={waiting} onClick={run}>Probar aviso</Button>
      {r && (
        <p className="text-xs text-[var(--text-muted)]">
          Última prueba: {r.devices === 0 ? 'este teléfono no está registrado para notificaciones (abre la app y acepta el permiso de notificaciones).' : r.results.map((x) => (x.ok ? `enviado a ${x.device.slice(0, 30)}` : `error en ${x.device.slice(0, 30)}: ${x.error}`)).join(' · ')}
        </p>
      )}
    </Card>
  );
}
